import React from 'react'
import { Gift, Download, Mail, Star } from 'lucide-react'

const Benefits: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="container-width section-padding">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-8">
            <Gift className="w-10 h-10 text-green-600" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-green-600">즉시 받는</span> 보너스
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            구독과 동시에 받는 특별 혜택
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-green-200 mb-12">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full mb-8">
                <Download className="w-12 h-12 text-white" />
              </div>
              
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                "실전 AI 툴 가이드"
              </h3>
              
              <div className="bg-green-50 p-6 rounded-2xl border border-green-200 mb-8">
                <p className="text-lg text-gray-800 font-medium mb-4">
                  🤖 <strong>AI 에이전트를 위한 가이드</strong>
                </p>
                <ul className="text-left text-gray-700 space-y-2 max-w-2xl mx-auto">
                  <li>• ChatGPT, Claude, Gemini 고급 활용법</li>
                  <li>• 업무 자동화를 위한 AI 워크플로우</li>
                  <li>• 개발자를 위한 AI 코딩 도구 완전 정복</li>
                  <li>• AI 이미지/영상 생성 도구 실전 가이드</li>
                </ul>
              </div>
              
              <div className="flex items-center justify-center gap-2 text-green-600 mb-6">
                <Mail className="w-6 h-6" />
                <span className="text-lg font-bold">가입 즉시 이메일로 전송</span>
              </div>
              
              <div className="text-gray-600">
                <p className="text-sm">
                  * 일반 판매가 ₩29,000 상당의 가이드를 무료로 제공
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-green-200 text-center">
              <Star className="w-12 h-12 text-yellow-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">프리미엄 품질</h3>
              <p className="text-gray-600">유료 서비스 수준의 고품질 콘텐츠</p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-blue-200 text-center">
              <Mail className="w-12 h-12 text-blue-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">매주 정기 발송</h3>
              <p className="text-gray-600">일정한 시간에 꾸준히 받아보세요</p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-purple-200 text-center">
              <Gift className="w-12 h-12 text-purple-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">추가 보너스</h3>
              <p className="text-gray-600">구독자 전용 특별 콘텐츠</p>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="inline-block bg-gradient-to-r from-green-500 to-emerald-500 text-white p-6 rounded-2xl">
              <p className="text-lg font-bold mb-2">🎁 한정 시간 보너스</p>
              <p className="text-sm">지금 구독하면 추가로 "AI 트렌드 예측 리포트"도 받아보세요</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Benefits
